import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { env } from '@/config/env';
import es from './locales/es.json';
import en from './locales/en.json';

export const resources = {
  es: { translation: es },
  en: { translation: en },
} as const;

export const supportedLanguages = ['es', 'en'] as const;
export type SupportedLanguage = (typeof supportedLanguages)[number];

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: env.defaultLanguage,
    supportedLngs: supportedLanguages,
    nonExplicitSupportedLngs: true,
    interpolation: { escapeValue: false },
    detection: {
      // ES por defecto: solo cambiamos por elección explícita del usuario
      // (querystring o preferencia guardada), no por el idioma del navegador.
      order: ['querystring', 'localStorage', 'htmlTag'],
      lookupQuerystring: 'lng',
      caches: ['localStorage'],
    },
  });

// Mantiene <html lang> sincronizado para accesibilidad y SEO.
i18n.on('languageChanged', (lng) => {
  document.documentElement.lang = lng;
});

export default i18n;
